import React, { useState, useEffect } from 'react'
import { AntModal, AntInput } from "components/AntComponents";
import { Button } from "antd";
import { Formik } from 'formik';
import { startupCrudFormSchema } from "./validations";

export function AddAmountForm({ visible, onClose, data, onSubmit }) {
    const INITIAL_FORM_DATA = {
        committedAmount: null,
    }
    const [isOpen, setIsOpen] = useState(false);
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);

    useEffect(() => {
        if (data) {
            setFormData(data);
        }
    }, [data]);

    useEffect(() => {
        setIsOpen(visible)
    }, [visible]);

    const closeModal = () => {
        setFormData(INITIAL_FORM_DATA);
        onClose();
        setIsOpen(false);
    }

    const handleSubmit = async (payload) => {
        onSubmit(payload);
        closeModal();
    }

    return (
        <AntModal
            title={`Committed Amount`}
            isOpen={isOpen}
            onClose={closeModal}
            options={{
                width: "40%"
            }}
        >
            <Formik
                initialValues={formData}
                enableReinitialize
                validationSchema={startupCrudFormSchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleSubmit,
                    setFieldValue,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <p>Startup basic details</p>
                        <div className="grid grid-cols-2 gap-10 mb-2">
                            <AntInput
                                value={values.committedAmount}
                                setFieldValue={setFieldValue}
                                fieldName={"committedAmount"}
                                errors={errors}
                                touched={touched}
                                isRequired
                            />
                        </div>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="flex flex-row-reverse"
                        >
                            Commit Amount
                        </Button>
                    </form>
                )}
            </Formik>
        </AntModal>
    )
}
